<script lang="ts" setup>
import { ref } from "vue";
import { mdiArrowLeft, mdiArrowRight, mdiFormatQuoteOpen } from "@mdi/js";

type Testimonial = {
  author: string;
  avatar: string;
  text: string;
  position: string;
};

const activeTestimonial = ref(0);

function prev(): void {
  activeTestimonial.value =
    activeTestimonial.value === 0
      ? testimonials.length - 1
      : activeTestimonial.value - 1;
}

function next(): void {
  activeTestimonial.value =
    activeTestimonial.value === testimonials.length - 1
      ? 0
      : activeTestimonial.value + 1;
}

const testimonials: Testimonial[] = [
  {
    text: "De zeer eenvoudige manier om oefeningen klaar te zetten spreekt ons zeer aan. Doordat er verschillende games aan kunnen worden gekoppeld blijven de kinderen actief en enthousiast voor dit programma.",
    avatar: "bor.jpg",
    author: "Bor Wijnker",
    position: "BS Het Kleurenorkest (Limmen)",
  },
  {
    text: "In mijn rt-praktijk gebruik ik Taalblobs om de spellingregel, die ik een bepaalde week aan de orde stel, in te oefenen. Bovendien herhaal ik ook oude spellingregels. Ze kunnen de spellingwoorden ook als leesopdracht gebruiken in het programma.",
    avatar: "jennechien.jpg",
    author: "Jennechien Tiemens",
    position: "RT-praktijk Tiemens teaching (Zwolle)",
  },
  {
    text: "De kinderen zijn heel enthousiast over de spellen van taalblob. Zelfs in de vakantie loggen veel kinderen in om te oefenen. Mooi dat er zo al spelenderwijs geoefend wordt.",
    avatar: "harrie.jpg",
    author: "Harrie Meinen",
    position: "CBS De Kardoen (Ommen)",
  },
  {
    text: "Leerlingen worden weer enthousiast over het werken aan spelling, het zorgt voor een flinke boost! Door de afwisseling in spelletjes en oefeningen is het voor de kinderen een leuke activiteit!",
    avatar: "menno.jpg",
    author: "Menno van Harten",
    position: "Basisschool 't Prisma (Doetinchem)",
  },
  {
    text: "Door taalblobs te gebruiken wordt het intensief oefenen van lezen en spellen een stuk leuker! Veel uitdagende spelletjes zorgen voor veel oefenen met plezier!",
    avatar: "diny.jpg",
    author: "Diny Boot",
    position: "Klanktoren (Ugchelen)",
  },
];
</script>

<template>
  <v-container class="py-12" style="max-width: 80rem">
    <h2 class="pb-6" style="font-size: 2rem">
      Wat docenten over Taalblobs zeggen
    </h2>
    <v-carousel
      v-model="activeTestimonial"
      hide-delimiters
      :show-arrows="false"
      height="auto"
    >
      <v-carousel-item
        v-for="(testimonial, index) in testimonials"
        :key="index"
      >
        <div class="d-flex">
          <div class="d-none d-sm-block pr-16 flex-shrink-0 pt-10">
            <img
              loading="lazy"
              class="rounded-lg d-block"
              style="height: 10rem; max-width: 100%; object-fit: cover"
              width="150"
              height="150"
              :alt="testimonial.author"
              :src="`/assets/avatars/${testimonial.avatar}`"
            />
          </div>
          <div class="pl-sm-6 pl-md-6">
            <h2
              class="text-h5 font-weight-bold pb-6 pt-10"
              style="max-width: 40ch; position: relative"
            >
              <v-icon
                class="d-none d-sm-block"
                size="200"
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  opacity: 0.1;
                  transform: translateY(-25%) translateX(-50%);
                  z-index: -1;
                "
              >
                {{ mdiFormatQuoteOpen }}
              </v-icon>
              <q>{{ testimonial.text }}</q>
            </h2>
            <div class="d-inline-flex align-center">
              <img
                loading="lazy"
                class="rounded-lg d-block d-sm-none mr-4"
                style="height: 2rem; width: 2rem; object-fit: cover"
                :alt="testimonial.author"
                width="50"
                height="50"
                :src="`/assets/avatars/${testimonial.avatar}`"
              />
              <p class="ma-0 font-weight-bold">
                {{ testimonial.author }}
              </p>
              <span class="px-2">|</span>
              <p class="ma-0">{{ testimonial.position }}</p>
            </div>
          </div>
        </div>
      </v-carousel-item>
    </v-carousel>
    <div class="pt-6 d-flex justify-center">
      <v-btn @click="prev()" icon class="mr-2" aria-label="Vorige testimonial">
        <v-icon size="30">{{ mdiArrowLeft }}</v-icon>
      </v-btn>
      <v-btn @click="next()" icon aria-label="Volgende testimonial">
        <v-icon size="30">{{ mdiArrowRight }}</v-icon>
      </v-btn>
    </div>
  </v-container>
</template>
